<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">   
      <div class="pledge-box1-top">
        <label class="el-radio"> 
          <span class="el-radio-input is-checked" :class="{'is-checked': reporting}" @click="reporting=true, curDateType = finance[0][0]"> 
            <span class="el-radio-inner"></span> 
            <input class="el-radio-original" value="按报告期" type="radio">
          </span> 
          <span class="el-radio-label">按报告期</span> 
        </label>
        <label class="el-radio"> 
          <span class="el-radio-input" :class="{'is-checked': !reporting}" @click="reporting=false, curDateType = yearList[0][0]"> 
            <span class="el-radio-inner"></span> 
            <input class="el-radio-original" value="按年度" type="radio">
          </span> 
          <span class="el-radio-label">按年度</span> 
        </label>

        <div class="Quarterly-Report">
          <div class="head-title" @click.stop="showDateDropmemu($event)">
            {{ curDateType }}
            <span class="close-bot" @click.stop="showDateDropmemu($event)"></span>
          </div>
          <ul class="menu-lanmu" v-show="dateDropmenu && reporting">
            <li v-for="h in finance">
              <a href="javascript:;" v-if="curDateType != h[0]" @click="clickDropmenu(), curDateType = h[0]">{{ h[0] }}</a>
            </li>   
          </ul>
           <ul class="menu-lanmu" v-show="dateDropmenu && !reporting">  
            <li v-for="h in yearList">
              <a href="javascript:;" v-if="curDateType != h[0]" @click="clickDropmenu(), curDateType = h[0]">{{ h[0] }}</a>
            </li>   
          </ul>
        </div>
      </div>

      <div class="Single-list-main" v-if="reporting">  
        <ul class="Single-list-box">
          <li v-for="(key, val) in lrb" track-by="$index">
            <p class="date">{{ key }}</p> 
            <template  v-for="v in finance">
              <p class="time" v-if="v[0] == curDateType"> {{ v[1][val] ? v[1][val] : '--' | money }} </p>
            </template>
          </li> 
        </ul>   
      </div>

      <div class="Single-list-main" v-if="!reporting">  
        <ul class="Single-list-box">
          <li v-for="(key, val) in lrb" track-by="$index">
            <p class="date">{{ key }}</p> 
            <template  v-for="v in yearList">
              <p class="time" v-if="v[0] == curDateType"> {{ v[1][val] ? v[1][val] : '--' | money }} </p>
            </template>
          </li>  
        </ul>   
      </div>

     <!--  <div class="Single-list-main" v-if="lrb.length === 0"> 
        <div class="Block-trade-no">暂无数据</div>
      </div>  --> 

    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import echartMix from '../../common/echartMix'
  import echarts from 'echarts'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'FinanceView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, echartMix, wxshareMix],
    data () {
      return {
        reporting: true,    //按报告期
        curDateType: '',
        yearList: [],
        finance: [],
        lrb: {'营业总收入(元)': 'businessincometotal', '营业收入(元)': 'businessincome', '营业总成本(元)': 'operatingcoststotal', '营业成本(元)': 'operatingcosts', '营业税金及附加(元)': 'businesstax', '销售费用(元)': 'sellingexpenses', '管理费用(元)': 'handlingexpenses', '财务费用(元)': 'financingcosts', '资产减值损失(元)': 'assetimpairmentloss', '其他经营收益(元)': 'othercomprehensiveincome', '营业利润(元)': 'operatingprofit', '营业外收入(元)': 'nonbusinessincome', '营业外支出(元)': 'nonbusinessexpenditure', '利润总额(元)': 'totalprofits', '所得税(元)': 'incometax', '净利润(元)': 'retainedprofit', '归属于母公司股东的净利润(元)': 'retainedprofitowner', '每股收益(元)': 'earningpershare', '基本每股收益(元)': 'basicearningspershare', '稀释每股收益(元)': 'dilutedearningspershare', '综合收益总额(元)': 'totalcomprehensiveincome', '扣除非经常性损益后的净利润(元)': 'nonrecurrinlossprofit'},
          gblrb:{
            '基本每股收益(元)':'basiceps',
            '其他收入(元)':'otherincome',
            '出售资产之溢利(元)':'saleassetsprofit',
            '重估盈余(元)':'revaluationsurplus',
            '应占联营公司溢利(元)':'alliedcompanyprofit',
            '影响税前利润的其他项目(元)':'pretaxprofit',
            '每股股息(元)':'dividendsper',
            '本公司拥有人应占净利润(元)':'ownerretainedprofits',
            '所得税(元)':'incometax',
            '毛利(计算)(元)':'grossprofit',
            '其他支出(元)':'otherexpenses',
            '稀释每股收益(元)':'dilutedeps',
            '折旧和摊销(元)':'depreciationamortization',
            '研发费用(元)':'developmentfee',
            '资产减值损失(元)':'assetsimpairmentloss',
            '营业收入(计算)(元)':'businessincome',
            '股息(元)':'stockdividend',
            '影响净利润的其他项目(元)':'retainedprofits',
            '销售成本(元)':'costsales',
            '非控股权益应占全面收益总额(元)':'noncontrolcomprehensiveincome',
            '经营溢利(计算)(元)':'operatingprofit',
            '员工薪酬(元)':'compensation',
            '销售及分销成本(元)':'costsalesdistribution',
            '非控股权益应占净利润(元)':'noncontrolretainedprofits',
            '应占合营公司溢利(元)':'jointcompanyprofit',
            '其他全面收益(元)':'othercomprehensiveincome',
            '影响税前利润的其他项目(元)':'otherpretaxprofit',
            '影响净利润的其他项目(元)':'otherretainedprofits',
            '其他全面收益(元)':'comprehensiveincome',
            '本公司拥有人应占全面收益总额(元)':'ownercomprehensiveincome',
            '财务成本(元)':'financialcosts',
            '行政开支(元)':'administrativeexpenses'
        },
        dataMap: {'年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31'},
      }
    },
    route: {
      data({to}) {
        if(to.query.stype == 6){
          this.lrb = this.gblrb;
        }
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);

          this.setSelectedTab();
          this.getFinance();
        }
        
      }
    },
    methods: {
      getFinance: function() {
        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid
        this.loading = true;

        $.ajax({
          url: apiUrl('/V1.0.0/company/finance'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {
          
          this.loading = false;
          if (response.status === 0) {

            if (Object.keys(response.data).length) {

              let arr = []
              for (let k in response.data) {
                if (k.indexOf('年') >= 0) {
                  let n  = k.substr(0, 4) + this.dataMap[k.substr(4)]
                  arr.push([n, response.data[k]])
                } else {
                  arr.push([k, response.data[k]])
                }
              }

              arr.sort(function (a, b) {
                return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g,''))
              })
              if (arr.length > 6) {
                for (let i = 0; i<6;i++) {
                  this.finance.push(arr[i])
                }
              } else {
                this.finance = arr
              }
              for (let i of arr) {
                if (i[0].indexOf('-12-') >= 0) {
                  this.yearList.push(i)
                }
              }
              if (this.yearList.length > 5) {
                this.yearList = this.yearList.slice(0, 5)
              }

              // 初始按报告期
              this.reporting = true;
              this.curDateType = this.finance[0][0];
            }


          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },

      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
</style>


/** WEBPACK FOOTER **
 ** Lrb.vue?7c8bcb21
 **/